import queryString from 'query-string';
import type { IssueTypeResourceData } from '@jira/admin-pages__issue-types-common/src/IssueTypeScheme.types.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router
import { createResource } from '@atlassian/react-resource-router';
import { getIssueTypes } from './getIssueTypes.tsx';

// Used for fetching during SSR
export const issueTypesResource = createResource<IssueTypeResourceData>({
	type: 'GLOBAL_ADMIN_ISSUE_TYPES_DIRECTORY',
	getKey: () => 'issue types',
	getData: async ({ query }) => getIssueTypes(queryString.stringify(query)),
});
